import React from "react";
import PropTypes from "prop-types";
import styles from "./IBOAccountItem.module.css";
import classNames from "classnames";
import dayjs from "dayjs";

/**
 * Interactive component.
 * Displays details of accounts an IBO has in the Incident Records section of the IBO File page.
 */
export function IBOAccountItem({ index, account, onChange }) {
  return (
    <div
      className={classNames(styles.container, {
        [styles.dark]: index % 2 !== 0,
      })}
    >
      <div>{account.name}</div>
      <div>
        {account.updatedAt !== null
          ? dayjs(account.updatedAt).format("MM/DD/YY")
          : "N/A"}
      </div>
      <div className={styles.statusContainer}>
        <div>
          {account.status.charAt(0).toUpperCase() + account.status.slice(1)}
        </div>
      </div>
      <div>
        <div className={styles.lastItem} onClick={onChange}>
          Change Status
        </div>
      </div>
    </div>
  );
}

IBOAccountItem.propTypes = {
  /**
   * Used to determine background color.
   */
  index: PropTypes.number,
  /**
   * Object with the account's info.
   */
  account: PropTypes.shape({
    platform: PropTypes.string,
    dateEnrolled: PropTypes.string,
    status: PropTypes.string,
    reason: PropTypes.string,
  }),
  onChange: PropTypes.func,
};
